import { useEffect } from "react";

import LoginPages from "src/Layouts/LoginPages";
import { ResetPasswordView } from "src/organisms/ResetPasswordView";
import { useSegment } from "src/hooks/useSegment";
import { buildStaticProps } from "src/utils/static-props/app-page-props";

const ResetPassword = (): JSX.Element => {
  const { trackForgotPassword } = useSegment();

  useEffect(() => {
    void trackForgotPassword();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ResetPasswordView />;
};

ResetPassword.Layout = LoginPages;

export async function getStaticProps() {
  return buildStaticProps({});
}

export default ResetPassword;
